module.exports = __webpack_public_path__ + "static/media/building-content.a030330e.svg";